module.exports = __webpack_public_path__ + "img/teamImg24.dd93836e.jpg";